// extracted by mini-css-extract-plugin
export var FaqsBlock = "FaqsBlock-module--FaqsBlock--1181e";